import React, { useEffect, useMemo, useRef, useState } from 'react';
import style from './index.module.less';
import { CommonBackContent } from '../Layouts/CommonBackContent';
import RewriteTools from '@/components/Common/ToolsCommon/RewriteTool';
import RelevantProduction from '@/components/Common/ToolsCommon/RelevantProduction';
import { PlusCircleOutlined, DeleteOutlined, CopyOutlined } from '@ant-design/icons';
import { Input, Button, message } from 'antd';
import { postAiWriteApi, getAiWriteCountCount, postAiRewriteApi } from '@/lib/service';
import { useUserProvider } from '@/context/UserProvider';
import ThanksModal from '@/components/CaptionTool/thanksModal/index';
import { useTranslation } from 'next-i18next';
import dynamic from 'next/dynamic';
const FreQuestion = dynamic(() => import('./freQuestions/index'), {
  ssr: true,
});
const TwoBlogSec = dynamic(() => import('@/components/Common/TwoBlogSec'), {
  ssr: true,
});

const Index: React.FC<any> = ({ data }) => {
  const { t } = useTranslation('common');
  const { isLogin, onOpenLoginModal } = useUserProvider();
  const ShowInfo = useRef({
    title1: t('Why Choose Erasa’s'),
    title2: t('Captions Generator'),
    color: '#E9E9FF',
    mainList: [
      {
        title: t('Auto-Rewrite Sensitive Words, Publish with Ease:'),
        main: t(
          'Erasa smartly rewrites flagged words, helping your content pass reviews without the risk of bans or takedowns.',
        ),
        img: '/images/tool/r-2-1.webp',
      },
      {
        title: t('Keep the Creative Flow, Sound Natural:'),
        main: t(
          'Erasa preserves your original style and intent, ensuring rewrites are seamless and engaging without compromising on the reader experience.',
        ),
        img: '/images/tool/r-2-2.webp',
      },
      {
        title: t('Work Smarter, Save Time:'),
        main: t(
          'With Erasa handling the heavy lifting of word rewrites, you’ll cut down on manual reviews and focus more on creating great content.',
        ),
        img: '/images/tool/r-2-3.webp',
      },
      {
        title: t('Protect Your Brand, Maintain Your Image:'),
        main: t(
          'Keep your content professional and compliant, safeguarding your reputation and reducing the risk of violations.',
        ),
        img: '/images/tool/r-2-4.webp',
      },
    ],
  });
  const showProInfo = useRef({
    title: t('Other Relevant Products'),
    mainList: [
      {
        a: `${process.env.NEXT_APP_WEB_HOST}/${data.locale}/onlyfans-restricted-words-checker`,
        img: '/images/tool/1.webp',
        title: t('OnlyFans Restricted Word Checker'),
        desc: t('Scan for restricted words to keep your content compliant and avoid bans.'),
      },
      {
        a: `${process.env.NEXT_APP_WEB_HOST}/${data.locale}`,
        img: '/images/tool/2.webp',
        title: t('Unlimited Content Leak Removal'),
        desc: t(
          'Detect and remove leaked OnlyFans content，protecting your brand and earnings from unauthorized sharing.',
        ),
      },
    ],
  });
  const [rightStatus, setRightStatus] = useState(1);
  const [content, setContent] = useState('');
  const [power, setPower] = useState(0);
  const [dataInfo, setDataInfo] = useState<any>({});
  const [restric, setRestric] = useState({
    num: '',
    total_num: '',
  });
  const getRestTimes = () => {
    getAiWriteCountCount().then((res) => {
      setRestric(res.data);
    });
  };

  useEffect(() => {
    let str = localStorage.getItem('toolRetic');
    if (str) {
      setContent(str);
      localStorage.removeItem('toolRetic');
    }
    // 获取次数
    if (isLogin) {
      getRestTimes();
    }
  }, []);
  useEffect(() => {
    //获取次数
    if (isLogin) {
      getRestTimes();
    }
  }, [isLogin]);
  const isFirst = useRef(1);
  const handlePower = (status: number) => {
    if (status == power) {
      setPower(0);
      return;
    }
    if (status == 1 && dataInfo?.thumb_up_num == 0 && isFirst.current == 1) {
      isFirst.current = 2;
      setIsModalOpen(true);
    }
    // 1点赞 2down
    postAiRewriteApi(dataInfo.id, { status }).then((res) => {
      setPower(status);
    });
  };

  const handleTryAi = () => {
    if (content.length == 0) {
      message.warning('content cannot be blank');
      return;
    }
    if (!isLogin) {
      onOpenLoginModal(true);
      return;
    }
    if (restric?.num == '1') {
      setIsModalOpen(true);
    }
    setRightStatus(2);
    postAiWriteApi({ content }).then((res) => {
      if (res.code == 0) {
        res.data.content;
        setDataInfo(res.data);
        setRightStatus(3);
        let tempStr = {
          total_num: res.data.total_num,
          num: res.data.num,
        };
        setRestric(tempStr);
      } else {
        setRightStatus(1);
        message.warning(res.message);
      }
    });
  };
  const renderBr = useMemo(() => {
    let content = dataInfo.content;
    return content?.replaceAll('\n', '</br>');
  }, [dataInfo]);

  const handleCopy = (type: number) => {
    if (type == 1) {
      setContent(
        `Hi there, welcome to my page! 💖 
I delighted you're here 😇 I'm eager to connect more with you... 
I'm a tad reserved but I'm getting more comfortable, so please share your name and where you're from. 
♡ Exclusive videos! 
♡ Personalized content requests 
♡ Intimate voice messages 
♡ Access to private livestreams 
♡ And so much more... 💭 
Discover the exclusive content waiting for you here 🔑🔓... 
I'm thrilled to start this exciting journey together!! 💋💋💋"");`,
      );
    } else {
      if (navigator.clipboard) {
        // 使用异步 API 将文本写入剪贴板
        navigator.clipboard.writeText(dataInfo.content).then(() => {
          message.success(t('Content to copy to clipboard'));
        });
      }
      //   let oInput = document.createElement("input");
      //   oInput.value = dataInfo.content;
      //   document.body.appendChild(oInput);
      //   oInput.select();
      //   document.execCommand("Copy");
      //   oInput.remove();
      //   message.success("Content to copy to clipboard");
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <CommonBackContent>
      <div className={style.container}>
        <h1>{t('Free OnlyFans Caption Generator')}</h1>
        <div className={style.checkedTimes}>
          {t("Today's Usage")}{' '}
          <span>
            {restric?.num === '' ? '-' : restric?.num}/{restric?.total_num === '' ? '-' : restric?.total_num}
          </span>
        </div>
        <div className={style.main}>
          <div className={style.left}>
            <div className={style.main}>
              {/* 移动端 Loading - 通过 CSS 控制显示 */}
              {rightStatus == 2 && (
                <div className={style.MobileLoading}>
                  <div>
                    <img src="/images/erasa/protectedAccount/loading.webp" alt="" />
                    <span>Currently Creating...</span>
                  </div>
                </div>
              )}
              {/* 移动端结果显示 - 通过 CSS 控制显示 */}
              {rightStatus == 3 && (
                <div className={style.LeftMain}>
                  <div dangerouslySetInnerHTML={{ __html: renderBr }}></div>
                </div>
              )}
              {/* 桌面端输入框 - 通过 CSS 控制显示 */}
              <div className={style.ipt}>
                <Input.TextArea
                  placeholder={t('Enter or paste the OnlyFans content you want to rewrite or generate here.')}
                  value={content}
                  onChange={(e) => {
                    if (e.target.value.length > 10000) {
                      message.warning(t('Character limit of 10,000 exceeded'));
                      return;
                    }
                    setContent(e.target.value);
                  }}
                ></Input.TextArea>
              </div>
              {/* 移动端 Step3 操作 - 通过 CSS 控制显示 */}
              {rightStatus == 3 && (
                <div className={style.mobileStep3}>
                  <div>
                    <CopyOutlined onClick={() => handleCopy(2)} className={style.copyIcon} />
                  </div>
                  <div>
                    <img
                      onClick={() => handlePower(1)}
                      src={power == 1 ? '/images/tool/up1-1.svg' : '/images/tool/up1.svg'}
                      alt="up"
                    />
                    <img
                      onClick={() => handlePower(2)}
                      src={power == 2 ? '/images/tool/down1-1.svg' : '/images/tool/down1.svg'}
                      alt="down"
                    />
                  </div>
                </div>
              )}
              {/* 移动端字数统计 - 通过 CSS 控制显示 */}
              <div className={style.mobileWordCount}>
                {content.length > 0 && rightStatus == 1 && (
                  <div className={style.gar}>
                    <span>
                      {t('Total Words')}: {content.length}
                    </span>
                    <DeleteOutlined
                      className={style.icon}
                      onClick={() => {
                        setContent('');
                      }}
                    />
                  </div>
                )}
                {content.length == 0 && (
                  <div className={style.sample1} onClick={() => handleCopy(1)}>
                    <PlusCircleOutlined className={style.icon} />
                    <span>{t('Sample Text')}</span>
                  </div>
                )}
              </div>
            </div>
            <div className={style.opt}>
              {/* 桌面端字数统计 - 通过 CSS 控制显示 */}
              <div className={style.desktopWordCount}>
                {content.length > 0 && (
                  <div className={style.gar}>
                    <span>Total Words: {content.length}</span>
                    <DeleteOutlined
                      className={style.icon}
                      onClick={() => {
                        setContent('');
                      }}
                    />
                  </div>
                )}
                {content.length == 0 && (
                  <div className={style.sample} onClick={() => handleCopy(1)}>
                    <PlusCircleOutlined className={style.icon} />
                    <span>{t('Sample Text')}</span>
                  </div>
                )}
              </div>
              <div className={style.optBtn}>
                {/* 移动端 Step3 特殊按钮 - 通过 CSS 控制显示 */}
                {rightStatus == 3 && (
                  <Button
                    className={style.mobileClearButton}
                    onClick={() => {
                      setContent('');
                      setDataInfo({});
                      setPower(0);
                      setRightStatus(1);
                    }}
                  >
                    {t('Clear and Re-enter')}
                  </Button>
                )}
                {/* 常规按钮 - 通过 CSS 控制显示 */}
                <Button className={style.desktopRewriteButton} onClick={handleTryAi} loading={rightStatus == 2}>
                  {t('Try AI Rewrite')}
                </Button>
              </div>
            </div>
          </div>
          <div className={style.right}>
            {rightStatus == 1 && <div className={style.stepOne}>{t('Rewrite Display Area')}</div>}
            {rightStatus == 2 && (
              <div className={style.stepTow}>
                <div>
                  <img src="/images/erasa/protectedAccount/loading.webp" alt="" />
                  <span>{t('Currently Creating...')}</span>
                </div>
              </div>
            )}
            {rightStatus == 3 && (
              <div className={style.stepThree}>
                <div className={style.rightMain}>
                  <div dangerouslySetInnerHTML={{ __html: renderBr }}></div>
                </div>
                <div className={style.rightBottomOpt}>
                  <div onClick={() => handleCopy(2)}>
                    <CopyOutlined className={style.copyIcon} />
                  </div>
                  <div className={style.opt}>
                    <img
                      onClick={() => handlePower(1)}
                      src={power == 1 ? '/images/tool/up1-1.svg' : '/images/tool/up1.svg'}
                      alt="up"
                    />
                    <img
                      onClick={() => handlePower(2)}
                      src={power == 2 ? '/images/tool/down1-1.svg' : '/images/tool/down1.svg'}
                      alt="down"
                    />
                    <img src="/images/tools/allRight.webp" alt="right" />
                    <span>{t('Analysis complete')}</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <RewriteTools showInfo={ShowInfo.current}></RewriteTools>
        <RelevantProduction showProInfo={showProInfo.current}></RelevantProduction>
      </div>
      <ThanksModal isModalOpen={isModalOpen} handleClose={() => setIsModalOpen(false)}></ThanksModal>
      <TwoBlogSec
        blogList={data.data.blogList}
        topBlogList={data.data.topBlogList}
        blogTitle={data.data.contentInfo['section-blog']?.title ?? ''}
        topBlogTitle={data.data.contentInfo['section-top-blog']?.title ?? ''}
      />
      <FreQuestion data={data.data} />
    </CommonBackContent>
  );
};

export default Index;
